import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { GroupService } from 'tnx-admin-service/group/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, GridInfo, ModelSchema } from 'tnx-shared';

@Component({
    selector: 'app-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
    providers: [ComponentContextService]
})
export class GroupComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};

    constructor(
        protected _injector: Injector,
        protected _groupService: GroupService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.objectName = 'loại danh mục';
        this.setting.baseService = this._groupService;
        this.modelSchema = [
            new ModelSchema({ field: 'sort', name: 'Sắp xếp', fullName: 'Sắp xếp', description: '' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: '' }),
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên', description: '' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({
                field: 'code',
                label: this._translateService.instant('Mã'),
                fullTextSearch: true,
                width: '28em'
            }),
            new ColumnSchemaBase({
                field: 'name',
                label: this._translateService.instant('Tên'),
                fullTextSearch: true,
                width: '28em'
            }),
            new ColumnSchemaBase({
                field: 'description',
                label: this._translateService.instant('Mô tả')
            }),
            new ColumnSchemaBase({
                field: 'sort',
                width: '10em',
                label: this._translateService.instant('Thứ tự')
            }),
        ];
        super.ngOnInit();
    }

    async modifyGridInfo(gridInfo?: GridInfo) {
        if (!gridInfo.sorts.find(x => x.field == 'sort')) {
            gridInfo.sorts.splice(0, 0,
                { field: 'sort', dir: 1 }
            );
        }
    }

}
